import { ContainerItem } from "../../../redux/stagingBuilder/stagingBuilderTypes";

export const rateReducer = (total: number, _this: ContainerItem) =>
  total +
  (Number(_this.rentalRate) - Number(_this.discount)) *
    Number(_this.quantity) *
    _this.active;
export const retailReducer = (total: number, _this: ContainerItem) =>
  total + Number(_this.rentalPrice) * Number(_this.quantity) * _this.active;
